import SignUpForm from "../../components/SignUpForm/SignUpForm";
import { useState, useEffect } from "react";
import LoginForm from "../../components/LoginForm/LoginForm";
import { useNavigate } from "react-router-dom";

export default function AuthPage({ user, setUser }) {
  const [showSignUp, setShowSignUp] = useState(false);
  const navigate = useNavigate();

  // Already logged in — nothing to do here
  useEffect(() => {
    if (user) navigate("/");
  }, [user, navigate]);

  if (user) return null;

  return (
    <section className="flex items-center justify-center py-16">
      <div className="w-full max-w-sm rounded-2xl bg-white px-10 py-12 shadow-sm border border-gray-100">
        <h1 className="mb-1 text-center text-2xl font-semibold tracking-tight text-gray-900">
          {showSignUp ? "Sign up" : "Log in"}
        </h1>
        <p className="mb-8 text-center text-xs text-gray-400">
          Note: this login is for admins only
        </p>

        {showSignUp ? (
          <SignUpForm setUser={setUser} navigate={navigate} />
        ) : (
          <LoginForm setUser={setUser} />
        )}

        <p className="mt-8 text-center text-sm text-gray-500">
          {showSignUp ? "Already have an account?" : "Don't have an account?"}{" "}
          <button
            onClick={() => setShowSignUp(!showSignUp)}
            className="font-medium text-gray-900 underline underline-offset-2 transition-colors hover:text-pink-stamp"
          >
            {showSignUp ? "Log in" : "Sign up"}
          </button>
        </p>
      </div>
    </section>
  );
}
